// This file is generated by a script. Do not edit this file directly.
import React from 'react';
import { Base } from "./Base";
var SIZE_MAP = {
  xs: 'xs',
  sm: 'sm',
  base: 'base',
  lg: 'lg'
};
export function Body(_ref) {
  var children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$tag = _ref.tag,
    tag = _ref$tag === void 0 ? 'p' : _ref$tag,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'base' : _ref$size;
  return /*#__PURE__*/React.createElement(Base, {
    className: className,
    size: SIZE_MAP[size],
    variant: "body",
    tag: tag,
    leading: "normal",
    weight: "regular"
  }, children);
}
